import React from "react";

const SkillCategory = ({ skillCategory, revealIndex = 0 }) => (
  <div
    className="skill-panel"
    data-scroll-reveal="panel"
    style={{ "--reveal-delay": `${0.08 + revealIndex * 0.1}s` }}
  >
    <div className="skill-panel-header">
      <span className="skill-panel-icon">{skillCategory.icon}</span>
      <div>
        <h3>{skillCategory.category}</h3>
        <p>{skillCategory.description}</p>
      </div>
    </div>
    <div className="skill-chip-list">
      {skillCategory.skills.map((skill, chipIndex) => (
        <span
          key={skill.name}
          className="skill-chip"
          style={{
            "--chip-color": skill.color,
            "--chip-index": chipIndex,
          }}
        >
          <span className="skill-chip-name">{skill.name}</span>
          <span className="skill-chip-level">{skill.level}%</span>
        </span>
      ))}
    </div>
  </div>
);

export default SkillCategory;
